import Navbar from "./Components/Nav/Navbar";
import LeftPanel from "./Components/Left/LeftPanel";
import RightPanel from "./Components/Right/RightPanel";
import ContentPanel from "./Components/Content/ContentPanel";
import Footer from "./Components/Footer/Footer";
import  './App.css';

import 
{
 BrowserRouter,
 Routes,
 Route,
 Link
 
} from 'react-router-dom';


function App() {
  return (
    <BrowserRouter>
    <div className="App">
      <header className="App-header">
      <Navbar/>
      </header>
      <div className="container min_height">
          <div className="left-panel"><LeftPanel/></div>
          <div className="content-panel"><ContentPanel/></div>
          <div className="right-panel"><RightPanel/></div>
      </div>


      <div className="footer"><Footer/></div>

    </div>
    </BrowserRouter>
  );
}

export default App;
